import { useMutation, useQueryClient } from "@tanstack/react-query";
import { getApiErrorMessage, toApiError } from "../utils";
import api from "../../http";
import { useForBindingId } from '../../../forBinding';
import { CreateSoilAnalysisPayload } from "./types";


export const useUpdateSoilAnalysis = () => {
    const queryClient = useQueryClient();
    const forBinding = useForBindingId();
    return useMutation({
        mutationFn: async ({ id, data }: { id: string; data: CreateSoilAnalysisPayload }) => {
            try {
                return (await api.put(`/soil-analysis/update/${id}`, data, {
                    params: { forBinding },
                })).data;
            } catch (error) {
                throw toApiError(error, 'Erro ao atualizar análise de solo');
            }
        },
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({ queryKey: ['soilAnalysis'] });
            queryClient.invalidateQueries({ queryKey: ['soilAnalysisId', variables.id] });
        },
        onError: (error) => {
            console.error('Erro ao atualizar análise de solo:', getApiErrorMessage(error, 'Erro ao atualizar análise de solo'))
        },
    });
};
